import { Alert, Button, Container, Stack, Title } from '@mantine/core';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from '../auth/AuthProvider';
import { useNavigate } from 'react-router-dom';

/**
 * Login placeholder — éles auth még nincs.
 * Dev módban (BE: ALLOW_FAKE_LOGIN=true) a backend automatikusan
 * `dev@pta.local`-ként autentikál, így a "Belépés" gomb csak a /me-t kéri le
 * újra és redirektál /app-ra.
 */
export function LoginPage() {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate('/app', { replace: true });
  }, [user, navigate]);

  return (
    <Container size="xs" pt="xl">
      <Stack gap="md">
        <Title order={2}>Belépés</Title>
        <Alert color="yellow" title="Fejlesztői mód">
          Az auth-rendszer még nincs bekötve. A backend dev módban automatikusan
          a <code>dev@pta.local</code> userrel léptet be.
        </Alert>
        <Button onClick={() => void refresh()}>Belépés (dev)</Button>
        <Button component={Link} to="/" variant="subtle">
          Vissza a kezdőoldalra
        </Button>
      </Stack>
    </Container>
  );
}
